import { request } from './request';
import {
    LogSummary,
    IntervalType,
    TrackedLink,
    ExportLink,
    ExportFileFormats,
    CompressionFormat,
    BouncedCategorySummary,
    UserAgentStats,
} from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

export interface SummaryParams {
    from: string;
    to: string;
    channelName?: string;
    interval?: IntervalType;
    transactionID?: string;
}
export const loadSummary = (params: SummaryParams): AxiosPromise<LogSummary> => {
    const { Statistics } = request();
    return Statistics.reportsSummaryGet(params.from, params.to, params.channelName, params.interval, params.transactionID);
};

export const loadTodaySummary = loadSummary;

export const getBouncedSummary = (params: SummaryParams): AxiosPromise<BouncedCategorySummary> => {
    const { Statistics } = request();
    return Statistics.reportsBouncedsummaryGet(params.from, params.to, params.channelName);
};

export interface LinkTrackingParams {
    linkSearch?: string;
    from?: string;
    to?: string;
    limit?: number;
    offset?: number;
    channelName: string;
    activePage?: number;
    perPage?: number;
}

export const loadLinkTracking = (params: LinkTrackingParams): AxiosPromise<TrackedLink[]> => {
    const { Statistics } = request();
    return Statistics.reportsLinktrackingsGet(params.linkSearch, params.from, params.to, params.limit, params.offset, params.channelName);
};

export type ExportLinksParams = {
    from: string;
    to: string;
    channelName: string;
    fileFormat?: ExportFileFormats;
    compressionFormat?: CompressionFormat;
    fileName?: string;
    limit?: number;
    offset?: number;
};

export const exportLinks = (params: ExportLinksParams): AxiosPromise<ExportLink> => {
    const { Statistics } = request();
    const { from, to, channelName, fileFormat, compressionFormat, fileName, limit, offset } = params;

    return Statistics.reportsLinktrackingsExportGet(from, to, channelName, fileFormat, limit, offset, compressionFormat, fileName);
};

export interface DevicesParams {
    from?: string;
    to?: string;
}

export const getUserAgentStats = (params: DevicesParams): AxiosPromise<UserAgentStats[]> => {
    const { Reports } = request();

    return Reports.reportsUseragentsGet(params.from, params.to);
};

export interface DevicesChannelParams {
    channelName: string;
    from?: string;
    to?: string;
}

export const getUserAgentChannelStats = (params: DevicesChannelParams): AxiosPromise<UserAgentStats[]> => {
    const { Campaigns } = request();

    return Campaigns.campaignsByNameUseragentsGet(params.channelName, params.from, params.to);
};
